import React from 'react';

export const MessageContext = React.createContext({
  showErrorMessage: (_: any) => {},
  showSuccessMessage: (_: any) => {},
  showMessage: (_: any) => {},
});
export default MessageContext;
